import React from "react";
import { Box, Paper } from "@mui/material";
import LineItem from "../../common/component/LineItem";

export default function OrderDetails(props) {
  const { order } = props;

  return (
    <Paper elevation={0}>
      <Box px={0.5} py={2} pt={3} pb={1}>
        {order.items.map((item, idx) => (
          <Box key={idx} mb={1}>
            <LineItem item={item} view="min" />
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
